<template>
    
    <div id="signature-generator" class="signature-generator columns" v-bind:class="'sig-id' + load_signature_id + ' mode-' + this.mode">

        <div class="top-row" v-if="mode === 'admin'">
            <div class="signature-email-logo">
                <a href="/"><img v-bind:src="load_aws_url + '/website/signature-email-logo-mark.svg'" alt="Signature.email"></a>
            </div><!--- .signature-email-logo -->
            <div class="right-area d-flex">
                <a v-bind:href="sigEmailAdminUrl() + '/employees'" class="btn-icon btn-icon-wide btn-styles">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><path d="M144 160A80 80 0 1 0 144 0a80 80 0 1 0 0 160zm368 0A80 80 0 1 0 512 0a80 80 0 1 0 0 160zM0 298.7C0 310.4 9.6 320 21.3 320H234.7c.2 0 .4 0 .7 0c-26.6-23.5-43.3-57.8-43.3-96c0-7.6 .7-15 1.9-22.3c-13.6-6.3-28.7-9.7-44.6-9.7H106.7C47.8 192 0 239.8 0 298.7zM405.3 320H618.7c11.8 0 21.3-9.6 21.3-21.3C640 239.8 592.2 192 533.3 192H490.7c-15.9 0-31 3.5-44.6 9.7c1.3 7.2 1.9 14.7 1.9 22.3c0 38.2-16.8 72.5-43.3 96c.2 0 .4 0 .7 0zM320 176a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 144a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm-58.7 80H378.7c39.8 0 73.2 27.2 82.6 64H178.7c9.5-36.8 42.9-64 82.6-64zm0-48C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7H485.3c14.7 0 26.7-11.9 26.7-26.7C512 411.7 452.3 352 378.7 352H261.3z"/></svg>
                    <span class="btn-label">All Employees</span>
                </a>
                <a v-bind:href="sigEmailAdminUrl() + '/employees/' + employeeid" class="btn-icon btn-styles" v-if="employeeid">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M304 128a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM49.3 464H398.7c-8.9-63.3-63.3-112-129-112H178.3c-65.7 0-120.1 48.7-129 112zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3z"/></svg>
                    <span class="btn-label">View Employee</span>
                </a>
                <div class="menu-toggle-area">
                    <a href="#" v-on:click.prevent="menuToggle()" v-bind:class="{ 'active': menuActive }">
                        <span></span>
                        <span></span>
                        <span></span>
                    </a>
                </div><!-- .menu-toggle-area -->
            </div>
        </div><!-- .top-row -->

        <div class="main-column">

            <div class="email" v-bind:class="signatureHeightClass">

                <div class="email-header">
                    
                    <div class="words short"></div>
                    <div class="words short"></div>

                </div>

                <div class="email-body">
                    
                    <div class="words long"></div>
                    <div class="words long"></div>
                    <div class="words long hide-tall"></div>
                    <div class="words long hide-tall"></div>
                    <div class="words long hide-tall hide-medium hide-short-window"></div>
                    <div class="words long hide-tall hide-medium hide-short-window"></div>
                    <div class="words long hide-tall hide-medium hide-short-window"></div>
                    <div class="words long hide-tall hide-medium hide-short-window"></div>

                </div>

                <div class="signature-area" ref="signatureArea" v-if="loaded == true">

                    <div id="signature" class="signature preview-signature" ref="signature" v-html="createRawSignature()"></div>

                </div>

                <div class="signature-generator-loading" v-if="loaded == false"></div>

                <div class="email-action-buttons" v-if="loaded == true">
                    <div>
                        <button class="btn btn-primary btn-sm copy-to-clipboard" v-if="canCopySignature()" v-on:click.prevent="copyToClipboard"><svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="clipboard" class="svg-inline--fa fa-clipboard fa-w-12" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path fill="currentColor" d="M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 40c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm144 418c0 3.3-2.7 6-6 6H54c-3.3 0-6-2.7-6-6V118c0-3.3 2.7-6 6-6h42v36c0 6.6 5.4 12 12 12h168c6.6 0 12-5.4 12-12v-36h42c3.3 0 6 2.7 6 6z"></path></svg>Copy Signature to Clipboard</button>
                        <button class="btn btn-primary btn-sm select-signature" v-if="!canCopySignature() && !isiOS()" v-on:click.prevent="copyToClipboard"><svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="clipboard" class="svg-inline--fa fa-clipboard fa-w-12" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path fill="currentColor" d="M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 40c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm144 418c0 3.3-2.7 6-6 6H54c-3.3 0-6-2.7-6-6V118c0-3.3 2.7-6 6-6h42v36c0 6.6 5.4 12 12 12h168c6.6 0 12-5.4 12-12v-36h42c3.3 0 6 2.7 6 6z"></path></svg>Select Signature</button>
                        <button class="btn btn-primary btn-sm send-via-email" v-bind:class="{ disabled: signature_is_example }" v-on:click.prevent="sendSignature()"><svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="paper-plane" class="svg-inline--fa fa-paper-plane fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M440 6.5L24 246.4c-34.4 19.9-31.1 70.8 5.7 85.9L144 379.6V464c0 46.4 59.2 65.5 86.6 28.6l43.8-59.1 111.9 46.2c5.9 2.4 12.1 3.6 18.3 3.6 8.2 0 16.3-2.1 23.6-6.2 12.8-7.2 21.6-20 23.9-34.5l59.4-387.2c6.1-40.1-36.9-68.8-71.5-48.9zM192 464v-64.6l36.6 15.1L192 464zm212.6-28.7l-153.8-63.5L391 169.5c10.7-15.5-9.5-33.5-23.7-21.2L155.8 332.6 48 288 464 48l-59.4 387.3z"></path></svg>Send Via Email</button>
                        <button class="btn btn-primary btn-sm copy-sig-help" v-if="!canCopySignature()" v-on:click.prevent="signatureCopiedModal = true"><svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="life-ring" class="svg-inline--fa fa-life-ring fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm173.696 119.559l-63.399 63.399c-10.987-18.559-26.67-34.252-45.255-45.255l63.399-63.399a218.396 218.396 0 0 1 45.255 45.255zM256 352c-53.019 0-96-42.981-96-96s42.981-96 96-96 96 42.981 96 96-42.981 96-96 96zM127.559 82.304l63.399 63.399c-18.559 10.987-34.252 26.67-45.255 45.255l-63.399-63.399a218.372 218.372 0 0 1 45.255-45.255zM82.304 384.441l63.399-63.399c10.987 18.559 26.67 34.252 45.255 45.255l-63.399 63.399a218.396 218.396 0 0 1-45.255-45.255zm302.137 45.255l-63.399-63.399c18.559-10.987 34.252-26.67 45.255-45.255l63.399 63.399a218.403 218.403 0 0 1-45.255 45.255z"></path></svg>Help</button>
                    </div>
                    <div class="py-2 mobile-safari-instruction" v-if="isiOS()"><strong>It is NOT recommended to copy the signature on an iPhone or iPad!</strong> Click the <strong>Help</strong> button above for important instructions for iPhones and iPads.</div>
                </div><!-- .email-action-buttons -->

            </div><!-- .email -->

        </div><!-- .main-column -->

        <div class="sidebar-column">

            <div class="inside-sidebar-column">

                <div id="generate-signature" class="sidebar-column-type" v-if="activesidebar == 'generate'">

                    <div class="scrollable-inside" ref="sidebarscroll">
                    
                        <form v-if="loaded == true">

                            <h4 class="mb-3 font-weight-bold border-bottom pb-2 text-small text-uppercase bg-bluegray" v-if="mode === 'admin' && employeeid">
                                Editing Employee Signature
                            </h4>

                            <div class="mt-n2 mb-3" v-if="mode === 'admin' && employeeid && employeesignature_old">
                                <a href="/faq#faq-21" target="_blank" class="badge badge-pill badge-light-bluegray">Old Signature: Only Email Saved</a>
                            </div>

                            <div class="invalid-feedback mb-3" v-if="!validToCopy">One or more fields below are invalid or missing. Please edit the fields below and try&nbsp;again.</div>
                        
                            <template v-for="(line, lineindex) in signature.lines">
                                <div v-if="line.type == 'box'" v-bind:key="'box-line-' + lineindex">
                                    <div v-for="(subline, sublineindex) in line.lines" v-bind:key="'line-' + lineindex + '-box-' + sublineindex">
                                        <div class="form-group" v-for="(field, fieldindex) in subline.fields" v-if="field.editable !== 'no'" v-bind:key="'line-' + lineindex + '-box-line-' + sublineindex + '-field-' + fieldindex">
                                            <template v-if="field.editable !== 'no'">
                                                <label>{{ field.label }}<span class="optional" v-if="field.required === false && field.editable !== 'displaytoggle'"> (optional)</span></label>
                                            </template>
                                            <template v-if="field.editable == 'image' || field.editable == 'bothimagelink'">
                                                <file-upload v-bind:load-image-id="convertEmptyToNull(field.id)" v-bind:load-image-url="convertEmptyToNull(field.url)" v-bind:load-original-image-url="convertEmptyToNull(field.originalUrl)" v-bind:load-parent-id="convertEmptyToNull(field.parentId)" v-bind:load-crop-parent-id="convertEmptyToNull(field.cropParentId)" v-bind:image-root-url="getImageUrl()" v-on:updated="updateImage(field,$event)" v-on:deleted="deleteImage(field)" v-bind:load-cropping="field.cropping" v-bind:load-image-width="parseInt(field.width, 10)" v-bind:placeholder-image="field.placeholderImage" v-bind:load-editable="field.editable"></file-upload>
                                            </template>
                                            <template v-if="field.editable == 'value' || field.editable == 'bothlinkvalue'">
                                                <textarea class="form-control" v-bind:placeholder="field.placeholder" v-model="field.value" v-if="field.type == 'textarea'" v-on:change="checkSingleFieldValid(field)"></textarea>
                                                <select class="form-control" v-model="field.value" v-else-if="field.type == 'select'" v-on:change="checkSingleFieldValid(field)">
                                                    <option value="">Select</option>
                                                    <option v-for="(choice,index) in field.choices" v-text="getChoiceSelectLabel(choice)" v-bind:key="'choice-' + index" v-bind:value="index"></option>
                                                </select>
                                                <template v-else-if="field.type == 'selectimage'">
                                                    <div class="field-info choice-image-select" v-if="field.fieldDisplay == 'images'">
                                                        <div class="choice-image-select-area" v-for="(choice,index) in field.choices">
                                                            <a href="#" class="d-inline-block" v-bind:class="{ 'current': index === field.value }" v-on:click.prevent="selectImageChoice(choice, index, field)"><img v-bind:src="getImageChoiceUrl(choice)"></a>
                                                        </div>
                                                    </div>
                                                    <select class="form-control" v-model="field.value" v-else-if="field.fieldDisplay == 'select'" v-on:change="checkSingleFieldValid(field)">
                                                        <option value="">Select</option>
                                                        <option v-for="(choice,index) in field.choices" v-text="choice.choicelabel" v-bind:key="'choice-' + index" v-bind:value="index"></option>
                                                    </select>
                                                </template>
                                                <input type="text" class="form-control" v-bind:placeholder="field.placeholder" v-model="field.value" v-else v-on:change="checkSingleFieldValid(field)" v-bind:autocomplete="autoCompleteType(field)">
                                            </template>
                                            <template v-if="field.editable == 'link' || field.editable == 'bothimagelink' || field.editable == 'bothlinkvalue' || field.editable == 'linkasvalue'">
                                                <input type="text" class="form-control" v-bind:placeholder="linkPlaceholder(field)" v-model="field.link" v-on:change="checkSingleFieldValid(field)">
                                            </template>
                                            <template v-if="field.editable == 'displaytoggle'">
                                                <label class="switch">
                                                    <input type="checkbox" v-model="field.display">
                                                    <span class="slider round"></span>
                                                </label>
                                            </template>
                                            <div class="invalid-feedback" v-if="field.valid === false">Please fill in this required field.</div>
                                            <div class="helpful-notes" v-if="field.notes" v-text="field.notes"></div>
                                        </div>
                                    </div>
                                </div>
                                <div v-else-if="line.type == 'columns'" v-bind:key="'col-line-' + lineindex">
                                    <template v-for="(column, columnindex) in line.columns">
                                        <div v-for="(subline, sublineindex) in column.lines" v-bind:key="'line-' + lineindex + '-column-' + columnindex + '-' + sublineindex">
                                            <template v-if="subline.type == 'box'">
                                                <div v-for="(subsubline, subsublineindex) in subline.lines" v-bind:key="'line-' + lineindex + '-column-' + columnindex + '-subline-' + sublineindex + '-boxline-' + subsublineindex">
                                                    <div class="form-group" v-for="(field, fieldindex) in subsubline.fields" v-if="field.editable !== 'no'" v-bind:key="'line-' + lineindex + '-column-' + columnindex + '-subline-' + sublineindex + '-boxline-' + subsublineindex + '-field-' + fieldindex">
                                                        <template v-if="field.editable !== 'no'">
                                                            <label>{{ field.label }}<span class="optional" v-if="field.required === false && field.editable !== 'displaytoggle'"> (optional)</span></label>
                                                        </template>
                                                        <template v-if="field.editable == 'image' || field.editable == 'bothimagelink'">
                                                            <file-upload v-bind:load-image-id="convertEmptyToNull(field.id)" v-bind:load-image-url="convertEmptyToNull(field.url)" v-bind:load-original-image-url="convertEmptyToNull(field.originalUrl)" v-bind:load-parent-id="convertEmptyToNull(field.parentId)" v-bind:load-crop-parent-id="convertEmptyToNull(field.cropParentId)" v-bind:image-root-url="getImageUrl()" v-on:updated="updateImage(field,$event)" v-on:deleted="deleteImage(field)" v-bind:load-cropping="field.cropping" v-bind:load-image-width="parseInt(field.width, 10)" v-bind:placeholder-image="field.placeholderImage" v-bind:load-editable="field.editable"></file-upload>
                                                        </template>
                                                        <template v-if="field.editable == 'value' || field.editable == 'bothlinkvalue'">
                                                            <textarea class="form-control" v-bind:placeholder="field.placeholder" v-model="field.value" v-if="field.type == 'textarea'" v-on:change="checkSingleFieldValid(field)"></textarea>
                                                            <select class="form-control" v-model="field.value" v-else-if="field.type == 'select'" v-on:change="checkSingleFieldValid(field)">
                                                                <option value="">Select</option>
                                                                <option v-for="(choice,index) in field.choices" v-text="getChoiceSelectLabel(choice)" v-bind:key="'choice-' + index" v-bind:value="index"></option>
                                                            </select>
                                                            <template v-else-if="field.type == 'selectimage'">
                                                                <div class="field-info choice-image-select" v-if="field.fieldDisplay == 'images'">
                                                                    <div class="choice-image-select-area" v-for="(choice,index) in field.choices">
                                                                        <a href="#" class="d-inline-block" v-bind:class="{ 'current': index === field.value }" v-on:click.prevent="selectImageChoice(choice, index, field)"><img v-bind:src="getImageChoiceUrl(choice)"></a>
                                                                    </div>
                                                                </div>
                                                                <select class="form-control" v-model="field.value" v-else-if="field.fieldDisplay == 'select'" v-on:change="checkSingleFieldValid(field)">
                                                                    <option value="">Select</option>
                                                                    <option v-for="(choice,index) in field.choices" v-text="choice.choicelabel" v-bind:key="'choice-' + index" v-bind:value="index"></option>
                                                                </select>
                                                            </template>
                                                            <input type="text" class="form-control" v-bind:placeholder="field.placeholder" v-model="field.value" v-else v-on:change="checkSingleFieldValid(field)" v-bind:autocomplete="autoCompleteType(field)">
                                                        </template>
                                                        <template v-if="field.editable == 'link' || field.editable == 'bothimagelink' || field.editable == 'bothlinkvalue' || field.editable == 'linkasvalue'">
                                                            <input type="text" class="form-control" v-bind:placeholder="linkPlaceholder(field)" v-model="field.link" v-on:change="checkSingleFieldValid(field)">
                                                        </template>
                                                        <template v-if="field.editable == 'displaytoggle'">
                                                            <label class="switch">
                                                                <input type="checkbox" v-model="field.display">
                                                                <span class="slider round"></span>
                                                            </label>
                                                        </template>
                                                        <div class="invalid-feedback" v-if="field.valid === false">Please fill in this required field.</div>
                                                        <div class="helpful-notes" v-if="field.notes" v-text="field.notes"></div>
                                                    </div>
                                                </div>
                                            </template>
                                            <template v-else>
                                                <div class="form-group" v-for="(field, fieldindex) in subline.fields" v-if="field.editable !== 'no'" v-bind:key="'line-' + lineindex + '-column-' + columnindex + '-line-' + sublineindex + '-field-' + fieldindex">
                                                    <template v-if="field.editable !== 'no'">
                                                        <label>{{ field.label }}<span class="optional" v-if="field.required === false && field.editable !== 'displaytoggle'"> (optional)</span></label>
                                                    </template>
                                                    <template v-if="field.editable == 'image' || field.editable == 'bothimagelink'">
                                                        <file-upload v-bind:load-image-id="convertEmptyToNull(field.id)" v-bind:load-image-url="convertEmptyToNull(field.url)" v-bind:load-original-image-url="convertEmptyToNull(field.originalUrl)" v-bind:load-parent-id="convertEmptyToNull(field.parentId)" v-bind:load-crop-parent-id="convertEmptyToNull(field.cropParentId)" v-bind:image-root-url="getImageUrl()" v-on:updated="updateImage(field,$event)" v-on:deleted="deleteImage(field)" v-bind:load-cropping="field.cropping" v-bind:load-image-width="parseInt(field.width, 10)" v-bind:placeholder-image="field.placeholderImage" v-bind:load-editable="field.editable"></file-upload>
                                                    </template>
                                                    <template v-if="field.editable == 'value' || field.editable == 'bothlinkvalue'">
                                                        <textarea class="form-control" v-bind:placeholder="field.placeholder" v-model="field.value" v-if="field.type == 'textarea'" v-on:change="checkSingleFieldValid(field)"></textarea>
                                                        <select class="form-control" v-model="field.value" v-else-if="field.type == 'select'" v-on:change="checkSingleFieldValid(field)">
                                                            <option value="">Select</option>
                                                            <option v-for="(choice,index) in field.choices" v-text="getChoiceSelectLabel(choice)" v-bind:key="'choice-' + index" v-bind:value="index"></option>
                                                        </select>
                                                        <template v-else-if="field.type == 'selectimage'">
                                                            <div class="field-info choice-image-select" v-if="field.fieldDisplay == 'images'">
                                                                <div class="choice-image-select-area" v-for="(choice,index) in field.choices">
                                                                    <a href="#" class="d-inline-block" v-bind:class="{ 'current': index === field.value }" v-on:click.prevent="selectImageChoice(choice, index, field)"><img v-bind:src="getImageChoiceUrl(choice)"></a>
                                                                </div>
                                                            </div>
                                                            <select class="form-control" v-model="field.value" v-else-if="field.fieldDisplay == 'select'" v-on:change="checkSingleFieldValid(field)">
                                                                <option value="">Select</option>
                                                                <option v-for="(choice,index) in field.choices" v-text="choice.choicelabel" v-bind:key="'choice-' + index" v-bind:value="index"></option>
                                                            </select>
                                                        </template>
                                                        <input type="text" class="form-control" v-bind:placeholder="field.placeholder" v-model="field.value" v-else v-on:change="checkSingleFieldValid(field)" v-bind:autocomplete="autoCompleteType(field)">
                                                    </template>
                                                    <template v-if="field.editable == 'link' || field.editable == 'bothimagelink' || field.editable == 'bothlinkvalue' || field.editable == 'linkasvalue'">
                                                        <input type="text" class="form-control" v-bind:placeholder="linkPlaceholder(field)" v-model="field.link" v-on:change="checkSingleFieldValid(field)">
                                                    </template>
                                                    <template v-if="field.editable == 'displaytoggle'">
                                                        <label class="switch">
                                                            <input type="checkbox" v-model="field.display">
                                                            <span class="slider round"></span>
                                                        </label>
                                                    </template>
                                                    <div class="invalid-feedback" v-if="field.valid === false">Please fill in this required field.</div>
                                                    <div class="helpful-notes" v-if="field.notes" v-text="field.notes"></div>
                                                </div>
                                            </template>
                                        </div>
                                    </template>
                                </div>
                                <div v-else v-bind:key="'line-' + lineindex">
                                    <div class="form-group" v-for="(field, fieldindex) in line.fields" v-if="field.editable !== 'no'" v-bind:key="'line-' + lineindex + '-field-' + fieldindex">
                                        <template v-if="field.editable !== 'no'">
                                            <label>{{ field.label }}<span class="optional" v-if="field.required === false && field.editable !== 'displaytoggle'"> (optional)</span></label>
                                        </template>
                                        <template v-if="field.editable == 'image' || field.editable == 'bothimagelink'">
                                            <file-upload v-bind:load-image-id="convertEmptyToNull(field.id)" v-bind:load-image-url="convertEmptyToNull(field.url)" v-bind:load-original-image-url="convertEmptyToNull(field.originalUrl)" v-bind:load-parent-id="convertEmptyToNull(field.parentId)" v-bind:load-crop-parent-id="convertEmptyToNull(field.cropParentId)" v-bind:image-root-url="getImageUrl()" v-on:updated="updateImage(field,$event)" v-on:deleted="deleteImage(field)" v-bind:load-cropping="field.cropping" v-bind:load-image-width="parseInt(field.width, 10)" v-bind:placeholder-image="field.placeholderImage" v-bind:load-editable="field.editable"></file-upload>
                                        </template>
                                        <template v-if="field.editable == 'value' || field.editable == 'bothlinkvalue'">
                                            <textarea class="form-control" v-bind:placeholder="field.placeholder" v-model="field.value" v-if="field.type == 'textarea'" v-on:change="checkSingleFieldValid(field)"></textarea>
                                            <select class="form-control" v-model="field.value" v-else-if="field.type == 'select'" v-on:change="checkSingleFieldValid(field)">
                                                <option value="">Select</option>
                                                <option v-for="(choice,index) in field.choices" v-text="getChoiceSelectLabel(choice)" v-bind:key="'choice-' + index" v-bind:value="index"></option>
                                            </select>
                                            <template v-else-if="field.type == 'selectimage'">
                                                <div class="field-info choice-image-select" v-if="field.fieldDisplay == 'images'">
                                                    <div class="choice-image-select-area" v-for="(choice,index) in field.choices">
                                                        <a href="#" class="d-inline-block" v-bind:class="{ 'current': index === field.value }" v-on:click.prevent="selectImageChoice(choice, index, field)"><img v-bind:src="getImageChoiceUrl(choice)"></a>
                                                    </div>
                                                </div>
                                                <select class="form-control" v-model="field.value" v-else-if="field.fieldDisplay == 'select'" v-on:change="checkSingleFieldValid(field)">
                                                    <option value="">Select</option>
                                                    <option v-for="(choice,index) in field.choices" v-text="choice.choicelabel" v-bind:key="'choice-' + index" v-bind:value="index"></option>
                                                </select>
                                            </template>
                                            <input type="text" class="form-control" v-bind:placeholder="field.placeholder" v-model="field.value" v-else v-on:change="checkSingleFieldValid(field)" v-bind:autocomplete="autoCompleteType(field)">
                                        </template>
                                        <template v-if="field.editable == 'link' || field.editable == 'bothimagelink' || field.editable == 'bothlinkvalue' || field.editable == 'linkasvalue'">
                                            <input type="text" class="form-control" v-bind:placeholder="linkPlaceholder(field)" v-model="field.link" v-on:change="checkSingleFieldValid(field)">
                                        </template>
                                        <template v-if="field.editable == 'displaytoggle'">
                                            <label class="switch">
                                                <input type="checkbox" v-model="field.display">
                                                <span class="slider round"></span>
                                            </label>
                                        </template>
                                        <div class="invalid-feedback" v-if="field.valid === false">Please fill in this required field.</div>
                                        <div class="helpful-notes" v-if="field.notes" v-text="field.notes"></div>
                                    </div>
                                </div>
                            </template>

                            <div class="form-group" v-if="hasEditableRequiredEmail === false">
                                <label>Email</label>
                                <input type="email" class="form-control" placeholder="you@company.com" v-model="statsEmail" v-on:change="checkStatsEmail()" autocomplete="email">
                                <div class="invalid-feedback" v-if="!statsEmailValid" >A valid email address is required.</div>
                            </div>
                        
                        </form>

                    </div><!-- .scrollable-inside -->

                </div><!-- #generate-signature -->

                <div id="main-menu" class="sidebar-column-type" v-show="activesidebar == 'menu'">

                    <div class="scrollable-inside">

                        <ul class="main-menu-menu" v-if="user_id && organization_id">
                            <li class="signatures"><a v-bind:href="sigEmailAdminUrl() + '/signatures'">Manage Signatures</a></li>
                            <li class="employees"><a v-bind:href="sigEmailAdminUrl() + '/employees'">View Employees</a></li>
                            <li class="billing" ><a v-bind:href="sigEmailAdminUrl() + '/billing'">Billing &amp; Invoices</a></li>
                            <li class="org-users"><a v-bind:href="sigEmailAdminUrl() + '/users'">Organization Users</a></li>
                            <li class="myaccount"><a v-bind:href="sigEmailAdminUrl() + '/account'">My Account</a></li>
                        </ul>

                        <ul class="main-menu-menu">
                            <li class="home"><a v-bind:href="sigEmailAdminUrl()">Home</a></li>
                            <li class="pricing"><a v-bind:href="sigEmailAdminUrl() + '/pricing'">Pricing</a></li>
                            <li class="guides"><a v-bind:href="sigEmailAdminUrl() + '/guides'">Guides</a></li>
                            <li class="blog"><a v-bind:href="sigEmailAdminUrl() + '/blog'">Blog</a></li>
                            <li class="maker"><a v-bind:href="sigEmailAdminUrl() + '/founder'">Founder</a></li>
                            <li class="faq"><a v-bind:href="sigEmailAdminUrl() + '/faq'">FAQs</a></li>
                            <li class="contact"><a v-bind:href="sigEmailAdminUrl() + '/contact'">Contact</a></li>
                        </ul>

                    </div><!-- .scrollable-inside -->

                </div><!-- #main-menu -->
                    
            </div><!-- .inside-sidebar-column -->

            <div class="save-box" v-if="mode === 'admin' && organization && organization.old_mode_no_employee_sigs === false">
                <button class="btn btn-primary btn-preview" v-on:click.prevent="startSaveEmployeeSignature()" key="saveemployeesig">
                    <svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="pencil-alt" class="svg-inline--fa fa-floppy-disk fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M32 96c0-17.7 14.3-32 32-32l0 96c0 17.7 14.3 32 32 32H288c17.7 0 32-14.3 32-32V65.8c4.5 1.6 8.7 4.2 12.1 7.6l74.5 74.5c6 6 9.4 14.1 9.4 22.6V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96zM96 64H288v96H96V64zM0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V170.5c0-17-6.7-33.3-18.7-45.3L354.7 50.7c-12-12-28.3-18.7-45.3-18.7H64C28.7 32 0 60.7 0 96zM272 320a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm-48-80a80 80 0 1 0 0 160 80 80 0 1 0 0-160z"/></svg>
                    <span>Save Employee Signature</span>
                </button>
            </div><!-- .save-box -->
            <div class="save-box" v-if="mode === 'generator' && employeesignatureslug">
                <button class="btn btn-primary btn-preview" v-on:click.prevent="startSaveEmployeeSignature()" key="saveemployeesig2">
                    <svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="pencil-alt" class="svg-inline--fa fa-floppy-disk fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M32 96c0-17.7 14.3-32 32-32l0 96c0 17.7 14.3 32 32 32H288c17.7 0 32-14.3 32-32V65.8c4.5 1.6 8.7 4.2 12.1 7.6l74.5 74.5c6 6 9.4 14.1 9.4 22.6V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96zM96 64H288v96H96V64zM0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V170.5c0-17-6.7-33.3-18.7-45.3L354.7 50.7c-12-12-28.3-18.7-45.3-18.7H64C28.7 32 0 60.7 0 96zM272 320a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm-48-80a80 80 0 1 0 0 160 80 80 0 1 0 0-160z"/></svg>
                    <span>Save My Signature</span>
                </button>
            </div><!-- .save-box -->

        </div><!-- .sidebar-column -->

        <div id="send-email-modal" class="send-email-modal modal ui-light-theme" v-bind:class="{ show: showSendEmailModal }" tabindex="-1" role="dialog" aria-modal="true" v-if="showSendEmailModal" v-on:click.self.prevent="showSendEmailModal = false">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Send Signature Via Email</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" v-on:click.prevent="showSendEmailModal = false">
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form method="POST">
                            <div class="form-group">
                                <label class="modal-form-label">Email Address to Send Signature</label>
                                <input type="email" name="email" class="form-control" placeholder="Email Address" v-model="sendSignatureEmail">
                                <span class="invalid-feedback show-invalid" role="alert" v-if="sendEmailError">
                                    <strong v-text="sendEmailError"></strong>
                                </span>
                            </div>
                            <div class="form-group">
                                <label class="modal-form-label">Email for Replies <span class="optional">(recommended)</span></label>
                                <input type="email" name="email" class="form-control" placeholder="Email Address" v-model="sendSignatureReplyEmail">
                                <span class="invalid-feedback show-invalid" role="alert" v-if="sendEmailError">
                                    <strong v-text="sendEmailError"></strong>
                                </span>
                            </div>
                            <div class="form-group">
                                <label class="modal-form-label">Include Signature Editing Link</label>
                                <div v-if="published && signature_slug !== null">
                                    <label class="switch m-0">
                                        <input type="checkbox" v-model="sendSignatureEmailEdit">
                                        <span class="slider round"></span>
                                    </label>
                                </div>
                                <div v-else>
                                    <div class="switch m-0">
                                        <input type="checkbox" class="disabled" disabled>
                                        <span class="slider round"></span>
                                    </div>
                                    <div class="mt-1 color-light-gray text-xsmall">(Publish signature generator to send edit links)</div>
                                </div>
                                <span class="invalid-feedback show-invalid" role="alert" v-if="sendEmailError">
                                    <strong v-text="sendEmailError"></strong>
                                </span>
                            </div>
                            <button class="btn btn-lg btn-primary btn-block" v-on:click.prevent="sendSignatureNow()">Send Signature Now</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <div id="signature-copied-modal" class="signature-copied-modal modal ui-light-theme" v-bind:class="{ show: signatureCopiedModal }" tabindex="-1" role="dialog" aria-modal="true" v-if="signatureCopiedModal" v-on:click.self.prevent="hideSignatureCopiedModal()">
            <div class="modal-dialog" role="document">
                <div class="modal-content"> 
                    
                    <div class="modal-header">
                        <h5 class="modal-title" v-if="signatureDistributionMode == 'copy'">Signature Copied!</h5>
                        <h5 class="modal-title" v-else-if="signatureDistributionMode == 'email'">Signature Sent!</h5>
                        <h5 class="modal-title" v-else>Signature Copy & Paste Help</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" v-on:click.prevent="hideSignatureCopiedModal()">
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="alert alert-success" v-if="signatureDistributionMode == 'copy'">Signature copied to clipboard.</div>
                        <div class="alert alert-success" v-if="signatureDistributionMode == 'email'">Signature sent via email.</div>
                        <div class="alert alert-warning my-3" v-if="isDesktopSafari">It looks like you are using Safari for Desktop. Safari removes certain advanced formatting during the copy &amp; paste process. If your signature doesn't look right after pasting it, try copying it from another browser like Chrome or Firefox.</div>
                        <p>Want help from here? Choose your email browser for more detailed instructions:</p>
                        <ul class="email-browser-list" v-if="!chosenInstructions">
                            <li v-for="email_client in email_clients" v-bind:key="email_client.shortname"><a href="#" v-on:click.prevent="showInstructions(email_client.shortname)"><img v-bind:src="load_aws_url + email_client.logo"><h5 v-text="email_client.name"></h5></a></li>
                        </ul>
                        <div class="instructions" v-if="chosenInstructions">
                            <button class="btn btn-sm btn-primary go-back" v-on:click.prevent="chosenInstructions = null">Back</button>
                            <div class="instructions-inside" v-html="chosenInstructions"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div id="out-of-employees-modal" class="out-of-employees-modal modal ui-light-theme show" tabindex="-1" role="dialog" aria-modal="true" v-if="loaded && outOfEmployees">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Out of Employees</h5>
                    </div>
                    <div class="modal-body">
                        <p>Oh no! You have used up <strong>{{ totalEmployees }}</strong> of your <strong>{{ organization.allowed_employees }}</strong> employees included in your plan. You won't be able to create more until you delete some that are no longer needed or upgrade to a larger plan that fits your organization.</p>
                        <div><a v-bind:href="sigEmailAdminUrl() + '/employees'" class="btn btn-primary">Manage Employees</a></div>
                    </div>
                </div>
            </div>
        </div>

    </div>

</template>

<script>
    import VueCroppie from 'vue-croppie';
    import Signature from '../mixins/Signature';
    export default {
        props: {
            load_signature_id: {
                type: Number,
                default: null,
            },
            load_user_id: {
                type: Number,
                default: null,
            },
            load_empsigslug: {
                type: String,
                default: null,
            },
            load_employee_id: {
                type: Number,
                default: null,
            },
            load_employee_signature_id: {
                type: Number,
                default: null,
            },
            load_organization_id: {
                type: Number,
                default: null,
            },
            load_signature_name: {
                type: String,
                default: null,
            },
            load_signature_title: {
                type: String,
                default: null,
            },
            load_signature_slug: {
                type: String,
                default: null,
            },
            load_purchased: {
                type: Boolean,
                default: false,
            },
            disable_signature_tracks: {
                type: Boolean,
                default: false,
            },
            signature_is_example: {
                type: Boolean,
                default: false,
            },
            load_aws_url: {
                type: String,
                default: null,
            },
            load_env: {
                type: String,
                default: 'production',
            },
            mode: {
                type: String,
                default: 'employee',
            }
        },
        components: {
            VueCroppie,
        },
        mixins: [Signature],
        data: function () {
            return {
                view: 'generator',
                signatureid: null,
                employeesignatureslug: null,
                employeeid: null,
                employeesignatureid: null,
                employeesignature_old: false,
                user_id: null,
                single_signature: false,
                organization_id: null,
                organization: null,
                user: null,
                purchased: false,
                signature_name: null,
                signature_title: null,
                signature_slug: null,
                published: null, 
                loaded: false,
                statsEmail: null,
                statsEmailValid: true,

                previewActive: true,

                activesidebar: 'generate',
                lastsidebar: null,
                currentfield: null,
                currentline: null,
                colorPickerOpen: false, 
                colorPickerType: null,
                colorPickerProperty: null, 
                signatureHeightClass: 'short',

                hoverField: null,

                showAddFieldModal: false, 
                lineToAddFieldTo: null,
                showEmailSaveModal: false, 
                showPricingModal: false,
                showHelpModal: false,
                signatureCopiedModal: false,
                showPurchaseModal: false,

                showSendEmailModal: false,
                sendSignatureEmail: '',
                sendSignatureReplyEmail: '',
                sendSignatureEmailEdit: true,
                sendEmailError: false,

                validToCopy: true,
                signatureDistributionMode: null,
                totalEmployees: 0,

                purchaseSuccessful: false,

                chosenPlan: null,
                //copyCodeMode: false,
                signature: null,
            }
        },
        mounted: function() {
            //console.log(JSON.stringify(this.signature));
            if (this.load_signature_id) {
                this.signatureid = this.load_signature_id;
            }
            if (this.load_empsigslug) {
                this.employeesignatureslug = this.load_empsigslug;
            }
            if (this.load_employee_id) {
                this.employeeid = this.load_employee_id;
            }
            if (this.load_employee_signature_id) {
                this.employeesignatureid = this.load_employee_signature_id;
            }
            if (this.load_user_id) {
                this.user_id = this.load_user_id;
            }
            if (this.load_organization_id) {
                this.organization_id = this.load_organization_id;
            }
            if (this.load_signature_name) {
                this.signature_name = this.load_signature_name;
            }
            if (this.load_signature_title) {
                this.signature_title = this.load_signature_title;
            }
            if (this.load_signature_slug) {
                this.signature_slug = this.load_signature_slug;
            }
            if (this.load_purchased) {
                this.purchased = this.load_purchased;
            }
            var self = this;
            var urlToGet = '';
            if (self.employeesignatureslug) {
                urlToGet = '/signature/' + self.employeesignatureslug + '/data';
            } else if (self.employeeid && self.employeesignatureid) {
                urlToGet = '/employees/' + self.employeeid + '/signature/' + self.employeesignatureid + '/data';
            } else if (self.employeeid) {
                urlToGet = '/employees/' + self.employeeid + '/new/' + self.signatureid + '/data';
            } else if (self.signatureid) {
                urlToGet = '/signature/data/' + self.signatureid;
            } 
            // else {
            //     urlToGet = '/generator/data/'; //when would this ever be used??
            // }
            axios.get(urlToGet)
            .then(function(response) {
                self.signature = response.data.signature;
                self.sendSignatureEmailEdit = response.data.employee_edits;
                self.organization = response.data.organization;
                self.totalEmployees = response.data.total_employees;
                self.user = response.data.user;
                if (response.data.employee_email) {
                    self.statsEmail = response.data.employee_email;
                }
                if (response.data.published && response.data.published == true) {
                    self.published = true;
                }
                if (response.data.organization.default_reply_email) {
                    self.sendSignatureReplyEmail = response.data.organization.default_reply_email;
                } else if (response.data.user) {
                    self.sendSignatureReplyEmail = response.data.user.email;
                }
                if (response.data.employeesignature_old) {
                    self.employeesignature_old = response.data.employeesignature_old;
                }
                self.checkForOrgSupportedEmailApps();
                self.loaded = true;
                self.checkForEditableRequiredEmail('truefalse');
                self.recalculateSignatureHeightClass();
                self.turnOffInvalidRemindersOnLoad();
            }.bind(this)).catch(function(data) {
                console.log('error');
            });
        },
        computed: {
            // fieldKeys: function() {
            //     // var fieldKeys = [];
            //     // this.fields.forEach(function (field, key) {
            //     //     fieldKeys.push(key);
            //     // });
            //     return Object.keys(this.signature.fields);
            // },
            signatureLink: function() {
                return "https://" + this.signature_slug + ".signature.email";
            },
            menuActive: function() {
                if (this.activesidebar == 'menu') {
                    return true;
                } else {
                    return false;
                }
            },
            outOfEmployees: function() {
                if (this.employeeid === null && this.totalEmployees >= this.organization.allowed_employees && this.mode === 'admin') {
                    return true;
                } else {
                    return false;
                }
            }
        },
        methods: {
            turnOffInvalidRemindersOnLoad: function() {
                this.signature.lines.forEach(function ( line, lineindex ) {
                    if (line.type == 'box') {
                        line.lines.forEach(function ( boxline ) {
                            boxline.fields.forEach(function ( thefield, fieldindex ) {
                                if (thefield.valid === false) {
                                    thefield.valid = true;
                                }
                            });
                        }, line, this);
                    } else if (line.type == 'columns') {
                        line.columns.forEach(function ( column ) {
                            column.lines.forEach(function ( columnsline ) {
                                if (columnsline.type == 'box') {
                                    columnsline.lines.forEach(function ( boxline ) {
                                        boxline.fields.forEach(function ( thefield, fieldindex ) {
                                            if (thefield.valid === false) {
                                                thefield.valid = true;
                                            }
                                        }, line, this);
                                    }, line, this);
                                } else {
                                    columnsline.fields.forEach(function ( thefield, fieldindex ) {
                                        if (thefield.valid === false) {
                                            thefield.valid = true;
                                        }
                                    }, line, this);
                                }
                            }, line, this);
                        }, line, this);
                    } else {
                        line.fields.forEach(function ( thefield, fieldindex ) {
                            if (thefield.valid === false) {
                                thefield.valid = true;
                            }
                        }, this);
                    }
                }, this);
            },
            sigEmailAdminUrl: function() {
                if (this.load_env == 'development') {
                    return "http://signatureemail.lndo.site";
                } else {
                    return "https://signature.email";
                }
            },
            menuToggle: function() {
                this.previewActive = false;
                if (this.activesidebar == 'menu') {
                    this.activesidebar = this.lastsidebar;
                } else {
                    this.lastsidebar = this.activesidebar;
                    this.activesidebar = 'menu';
                }
            },
            currentLineClass: function(line) {
                if (this.currentline && this.activesidebar == 'lineEdit' && this.currentline === line) {
                    return true;
                } else {
                    return false;
                }
            },
            currentFieldClass: function(field) {
                if (this.currentfield && this.activesidebar == 'fieldEdit' && this.currentfield === field) {
                    return true;
                } else {
                    return false;
                }
            },
            hoverFieldClass: function(field) {
                if (field.hover && field.hover == true) {
                    return true;
                } else {
                    return false;
                }
            },
            fieldHoverOn: function(field) {
                field.hover = true;
            },
            fieldHoverOff: function(field) {
                field.hover = false;
            },
            sendSignature: function() {
                if (this.user_id) {
                    this.checkIfValidToCopy();
                    if (this.validToCopy) {
                        var destination;
                        if (this.hasEditableRequiredEmail) {
                            destination = this.checkForEditableRequiredEmail('fieldvalue');
                        } else {
                            destination = this.statsEmail;
                        }
                        this.sendSignatureEmail = destination;
                        this.showSendEmailModal = true;
                    }
                } else {
                    this.sendSignatureNow();
                }
            },
            sendSignatureNow: function() {
                var self = this;
                if (self.signature_is_example) {
                    alert("I'm sorry, this functionality has been disabled for this demo to prevent spam.");
                    return;
                }
                self.sendEmailError = null;
                self.triedToSubmit = true;
                var destination = null;
                self.checkIfValidToCopy();
                if (self.validToCopy) {
                    if (self.user_id && self.sendSignatureEmail) {
                        destination = self.sendSignatureEmail
                    } else if (self.hasEditableRequiredEmail) {
                        destination = self.checkForEditableRequiredEmail('fieldvalue');
                    } else {
                        destination = self.statsEmail;
                    }
                    if (this.signatureid && this.purchased) {
                        var urlToGet = '';
                        // if (self.employeesignatureslug) {
                        //     urlToGet = '/generator/send-signature';
                        // } else 
                        if (self.mode === 'admin' && self.employeeid && self.employeesignatureid) {
                            urlToGet = '/generator/send-signature';
                        } else if (self.mode === 'admin' && self.employeeid) {
                            urlToGet = '/generator/send-signature';
                        } else if (self.mode === 'admin' && !self.published) {
                            urlToGet = '/generator/send-signature';
                        } else {
                            urlToGet = '/send-signature';
                        }
                        axios.post(urlToGet, { id: this.signatureid, signature: this.signature, employee_signature_id: self.employeesignatureid, employee_id: self.employeeid, email: destination, destination: destination, reply: this.sendSignatureReplyEmail, edit: this.sendSignatureEmailEdit } )
                        .then(function (response) {
                            if (response.data.status == 'success') {
                                self.showSendEmailModal = false;
                                self.signatureDistributionMode = 'email';
                                self.signatureCopiedModal = true;
                                // Vue.notify({
                                //     group: 'bottomleftmessages',
                                //     title: 'Signature sent via email!',
                                //     type: 'success',
                                // });
                            } else if (response.data.status == 'error') {
                                Vue.notify({
                                    group: 'bottomleftmessages',
                                    title: response.data.message,
                                    type: 'error',
                                });

                            } else {
                                Vue.notify({
                                    group: 'bottomleftmessages',
                                    title: 'Sorry, there was a problem sending the email',
                                    type: 'error',
                                });
                            }
                        })
                        .catch(function (error) {
                            Vue.notify({
                                group: 'bottomleftmessages',
                                title: 'Sorry, there was a problem sending the email',
                                type: 'error',
                            });
                        });
                    }
                }
            },
            startSaveEmployeeSignature: function() {
                if (this.previewActive && this.single_signature == false) {
                    this.triedToSubmit = true;
                    this.checkIfValidToCopy();
                    if (this.validToCopy) {
                        this.saveEmployeeSignature();
                        // Vue.notify({
                        //     group: 'bottomleftmessages',
                        //     title: 'Employee signature saved!',
                        //     type: 'success',
                        // });
                    }
                }
            }
        }
    }
</script>